import { createApp } from "vue";
import { Quasar } from "quasar";
import "@quasar/extras/material-icons/material-icons.css";
import "quasar/src/css/index.sass";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/main.css";
import "@/assets/safe-area.css";
document.documentElement.setAttribute("lang", "es-CL");
const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(Quasar, {
    plugins: {},
    config: {
        brand: {
            primary: "#E84A1A",
            secondary: "#005D72",
            accent: "#003F4D",
            dark: "#003F4D",
            positive: "#16A34A",
            negative: "#DC2626",
            info: "#005D72",
            warning: "#F59E0B",
        },
    },
});
app.mount("#app");
